export const ERROR_CODES = {
  0: { desc: '请求成功' },
  200: { desc: '请求成功' },
  400: { desc: '请求参数错误' },
  401: { desc: 'APIkey 无效或过期' },
  403: { desc: '权限不足' },
  429: { desc: '请求频率超限' },
  500: { desc: '服务器内部错误' },
  503: { desc: '服务暂时不可用' }
}
